import React from "react";

import Select from "react-select";

import { Button, ButtonGroup, NumberLabel } from "aible";

import { ROLE_OPTIONS, ROLE_VALUES } from "containers/App/reducer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";
import SankeyChart from "components/Optimizer/SankeyChart";
import OptimizerPieChart from "components/Optimizer/OptimizerPieChart";
import ImpactSlider from "components/Optimizer/ImpactSlider";

import RunItemContainer from "containers/View/Item/RunItem";
import RunViewContainer from "containers/View/Run";
import RunPlotContainer from "containers/RunPlot/RunPlot";

import WizardContainer from "containers/Wizard/Wizard";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";

// TODO: Super lazy blocking the help chat

const darkSelectStyle = {
  option: (provided, state) => ({
    ...provided,
    background: state.isFocused ? "#512f77" : "#362e30",
    color: "white !important"
  }),
  control: (provided, state) => ({
    ...provided,
    background: "#362e44",
    border: "1px solid #828282",
    color: "white !important"
    // none of react-select's styles are passed to <Control />
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "white"
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: "0px",
    paddingBottom: "0px"
  })
};

export default class Optimizer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mode: "Overall",
      isRightOpen: false,
      isAFO: false,
      isEditSales: false,
      isEditMarketing: false,
      isEditSalesImpacts: false,
      isEditMarketingImpacts: false,
      isHideCustomValues: false,
      isSetup: false,
      timePeriod: { value: "Month", label: "Month" },
      drilldownColumn: undefined,
      setupSections: {},
      sharingOptions: {}
    };
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  renderAssumptionPanel() {
    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>{"Segment Update Requests"}</div>
        <div className={styles.rSubHeader}>{"Latam"}</div>
        <div>{"True positive benefit increased by 15%. False positive cost increased by 8%"}</div>
        <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
        <div className={styles.aUser}>{"Joe User"}</div>
        <div className={styles.segmentButtonHolder}>
          <Button style={{ marginRight: "10px" }}>{"Approve"}</Button>
          <Button style={{ marginRight: "10px" }}>{"Review"}</Button>
          <Button>{"Decline"}</Button>
        </div>
        <div className={styles.rSubHeader}>{"APAC"}</div>
        <div>{"True positive benefit decreased by 8%. False positive cost decreased by 2%"}</div>
        <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
        <div className={styles.aUser}>{"Joe User"}</div>
        <div className={styles.segmentButtonHolder}>
          <Button style={{ marginRight: "10px" }}>{"Approve"}</Button>
          <Button style={{ marginRight: "10px" }}>{"Review"}</Button>
          <Button>{"Decline"}</Button>
        </div>
      </div>
    );
  }

  renderSharing() {
    const { modelGroups } = this.props;

    const { sharingOptions } = this.state;

    const roleOptions = ROLE_OPTIONS;

    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>{"Sharing and Permissions"}</div>
        {modelGroups &&
          modelGroups.drilldownValues &&
          modelGroups.drilldownValues.map((v, i) => {
            const subKey = v.column + " - " + v.value;

            const emailKey = subKey + "-email";
            const roleKey = subKey + "-role";

            return (
              <div className={styles.shareItem} key={i}>
                <div className={styles.rSubHeader}>{subKey}</div>
                <LineInput isMediumBox placeholder="This is a description area users can edit" />
                <div className={styles.uHeader}>{"USERS"}</div>
                {sharingOptions[subKey] && sharingOptions[subKey].isEdit ? (
                  <div className={styles.userEdit}>
                    <div className={styles.userItem} style={{ marginBottom: "20px" }}>
                      <LineInput isMediumBox placeholder="Enter email address" ref={emailKey} />
                      <div className={styles.userRoleSelect}>
                        <Select options={roleOptions} defaultValue={roleOptions[0]} ref={roleKey} />
                      </div>
                      <Button
                        onClick={() => {
                          this.setState({
                            sharingOptions: {
                              ...sharingOptions,
                              [subKey]: {
                                ...sharingOptions[subKey],
                                users: {
                                  ...sharingOptions[subKey].users,
                                  [this.refs[emailKey].state.tempVal]: this.refs[roleKey].state.value
                                }
                              }
                            }
                          });

                          this.refs[emailKey].state.tempVal = "";
                          this.refs[emailKey].input.value = "";
                          this.refs[roleKey].state.value = roleOptions[0];
                        }}
                      >
                        {"Invite"}
                      </Button>
                    </div>
                    {sharingOptions &&
                      sharingOptions[subKey] &&
                      sharingOptions[subKey].users &&
                      Object.keys(sharingOptions[subKey].users).map((u, i) => (
                        <div key={i} className={styles.userItem}>
                          <div className={styles.userName}>{u}</div>
                          <div className={styles.userRoleSelect}>
                            <Select options={roleOptions} defaultValue={sharingOptions[subKey].users[u]} />
                          </div>
                          <Button
                            onClick={() => {
                              const sOptions = { ...sharingOptions };
                              delete sOptions[subKey].users[u];

                              this.setState({ sharingOptions: sOptions });
                            }}
                          >
                            {"Delete"}
                          </Button>
                        </div>
                      ))}
                    <Button
                      onClick={() =>
                        this.setState({
                          sharingOptions: {
                            ...sharingOptions,
                            [subKey]: {
                              ...sharingOptions[subKey],
                              isEdit: false
                            }
                          }
                        })
                      }
                    >
                      {"Done"}
                    </Button>
                  </div>
                ) : (
                  <div>
                    <span>
                      {(sharingOptions && sharingOptions[subKey] && sharingOptions[subKey].users
                        ? Object.keys(sharingOptions[subKey].users).length
                        : "0") + " Users"}
                    </span>
                    <a
                      onClick={() =>
                        this.setState({
                          sharingOptions: {
                            ...sharingOptions,
                            [subKey]: {
                              ...sharingOptions[subKey],
                              isEdit: true
                            }
                          }
                        })
                      }
                      style={{ marginLeft: "5px" }}
                    >
                      {"Edit Users"}
                    </a>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  }

  render() {
    const {
      optimizer,
      optimized,
      history,
      modelGroups,
      runs,
      handleCreateDrilldown,
      updateDrilldownValue,
      setFirstRunId,
      setSecondRunId
    } = this.props;
    const {
      mode,
      isEditSales,
      isEditMarketing,
      isRightOpen,
      isAFO,
      isSharing,
      isAssumptions,
      timePeriod,
      drilldownColumn,
      isSetup
    } = this.state;

    if (optimized === undefined) {
      return (
        <div className={styles.optimizer}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
          </div>
        </div>
      );
    }

    const runOptions = runs.map((r) => ({ value: r.id, label: r.name }));

    const firstRun =
      runs && optimizer && runs.filter((r) => r.id === optimizer.marketingRunId).length > 0
        ? runs.filter((r) => r.id === optimizer.marketingRunId)[0]
        : undefined;

    const secondRun =
      runs && optimizer && runs.filter((r) => r.id === optimizer.salesRunId).length > 0
        ? runs.filter((r) => r.id === optimizer.salesRunId)[0]
        : undefined;

    const drilldownOptions =
      firstRun && secondRun && firstRun.dataset && secondRun.dataset
        ? Object.keys(firstRun.dataset.fields)
            .filter((f) => secondRun.dataset.fields[f] && secondRun.dataset.fields[f].type === "categorical")
            .map((f) => ({ label: f, value: f }))
        : undefined;

    return (
      <div className={styles.optimizer}>
        <div className={styles.aibleForOne} style={{ width: isAFO ? "500px" : "0px" }}>
          {isAFO && <WizardContainer id={optimized.id} isConsumerMode />}
        </div>
        <div className={styles.rightP} style={{ width: isAssumptions ? "500px" : "0px" }}>
          {isAssumptions && this.renderAssumptionPanel()}
        </div>
        <div className={styles.rightP} style={{ width: isSharing ? "500px" : "0px" }}>
          {isSharing && this.renderSharing()}
        </div>
        <div className={styles.oHeader}>
          {modelGroups && modelGroups.hasGroup ? (
            <div className={styles.hItem}>
              <span style={{ fontWeight: "bold" }}>{modelGroups.drilldownColumn}</span>
              <Select
                options={modelGroups.drilldownValues}
                value={[
                  {
                    value: optimizer.drilldownValue,
                    label: optimizer.drilldownValue
                  }
                ]}
                onChange={(val) => updateDrilldownValue(val.runId, val.value)}
                className={styles.rSelect}
                styles={darkSelectStyle}
              />
            </div>
          ) : (
            <div className={styles.hItem} style={{ marginRight: "50px" }}>
              <Select
                options={drilldownOptions}
                onChange={(val) => this.setState({ drilldownColumn: val })}
                className={styles.rSelect}
                placeholder="Select Drilldown"
              />
              <Button disabled={drilldownColumn === undefined} onClick={() => handleCreateDrilldown(drilldownColumn)}>
                {"Create"}
              </Button>
            </div>
          )}
          {/*
          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button isDark onClick={() => history.push("/optimizer")}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
          </div>

          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button
              isDark
              active={isRightOpen}
              onClick={() => this.setState({ isRightOpen: !isRightOpen })}
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
          */}
          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button isDark active={isSetup} onClick={() => this.setState({ isSetup: !isSetup })}>
              {"Admin"}
            </Button>
          </div>
          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button
              isDark
              active={isSharing}
              onClick={() =>
                this.setState({
                  isSharing: !isSharing,
                  isAssumptions: false,
                  isAFO: false
                })
              }
            >
              {"Sharing"}
            </Button>
          </div>
          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button
              isDark
              active={isAssumptions}
              onClick={() =>
                this.setState({
                  isAssumptions: !isAssumptions,
                  isSharing: false,
                  isAFO: false
                })
              }
            >
              {"Assumptions"}
            </Button>
          </div>
          <div className={styles.hSelect} style={{ marginRight: "60px" }}>
            <Button
              isDark
              active={isAFO}
              onClick={() =>
                this.setState({
                  isAFO: !isAFO,
                  isSharing: false,
                  isAssumptions: false
                })
              }
            >
              {"Preview Aible for One"}
            </Button>
          </div>
          {mode === "Drilldown" && (
            <div className={styles.hSelect} style={{ marginRight: "20px" }}>
              <Button isDark active={mode === "Overall"} onClick={() => this.setState({ mode: "Overall" })}>
                {"Back"}
              </Button>
            </div>
          )}
          {mode === "Drilldown" && (
            <div style={{ marginRight: "10px" }}>
              <Button isDark active={isRightOpen} onClick={() => this.setState({ isRightOpen: !isRightOpen })}>
                {"Impacts"}
              </Button>
            </div>
          )}
          {/* TODO: Overall controls?
          <div className={styles.hSelect}>
            <ButtonGroup>
              <Button active={true}>{"Overall Optimal"}</Button>
              <Button>{"Marketing"}</Button>
              <Button>{"Sales"}</Button>
              <Button>{"Current State"}</Button>
            </ButtonGroup>
          </div>

          <Select
            options={runOptions}
            className={styles.rSelect}
            styles={darkSelectStyle}
            value={
              firstRun
                ? { value: firstRun.id, label: firstRun.name }
                : undefined
            }
            onChange={val => setFirstRunId(val.value)}
          />
          <Select
            options={runOptions}
            className={styles.rSelect}
            styles={darkSelectStyle}
            value={
              secondRun
                ? { value: secondRun.id, label: secondRun.name }
                : undefined
            }
            onChange={val => setSecondRunId(val.value)}
          />
          */}
        </div>
        {mode === "Overall" && this.renderOverall()}
        {mode === "Drilldown" && this.renderDrilldown()}
        {this.renderRightPanel()}
        {this.renderSetupPanel()}
      </div>
    );
  }

  renderProfitBox(style, hideButton = false) {
    const { optimized, optimizer, modelGroups } = this.props;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    return (
      <div className={styles.mItemMid + " " + styles.dropShadow} style={{ ...style }}>
        <div className={styles.newItemHeader}>{"Aible Optimized Profit"}</div>
        <div className={styles.newOItemContent}>
          <div className={styles.sTitle} style={{ justifyContent: "center" }}>
            {"Expected Profit"}
          </div>
          <div className={styles.cHero}>
            {(optimized.profit < 0 ? "-" : "") + "$"}
            <NumberLabel params={numberFormatParams}>{Math.abs(optimized.profit)}</NumberLabel>
            <span className={styles.oDelta + " " + (optimized.profitDelta > 0 ? styles.increase : styles.decrease)}>
              <FontAwesomeIcon
                style={{ marginRight: "2px" }}
                icon={optimized.profitDelta > 0 ? faArrowAltCircleUp : faArrowAltCircleDown}
              />
              <NumberLabel params={numberFormatParams}>{Math.abs(optimized.profitDelta)}</NumberLabel>
            </span>
          </div>
          <div className={styles.sSubItem}>
            <span>
              {"Profit " +
                (optimized.profitDelta > 0 ? "increases" : "decreases") +
                " to " +
                this.numberWithCommas(Math.round(optimized.profit)) +
                " from " +
                this.numberWithCommas(Math.round(optimized.currentProfit))}
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderOverall() {
    const {
      optimized,
      optimizer,
      modelGroups,
      groupInfo,
      setBudget,
      setSalesBudget,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCustomValue
    } = this.props;

    const { isEditMarketing, isEditSales, isEditMarketingImpacts, isEditSalesImpacts, isHideCustomValues } = this.state;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    const topDrivers =
      modelGroups &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue).length > 0
        ? modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue)[0]
        : undefined;

    let mTotal = 0;
    if (groupInfo.marketing[optimizer.drilldownValue]) {
      Object.keys(groupInfo.marketing[optimizer.drilldownValue]).forEach((v) => {
        mTotal += groupInfo.marketing[optimizer.drilldownValue][v].cost;
      });
    }

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = isHideCustomValues !== true && hasCustomValues;

    const drilldownSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((v) => v.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((v) => v.value === optimizer.drilldownValue)[0]
        : undefined;

    const otherSlices =
      drilldownSlice && modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues.filter(
            (v) => v.column && v.column !== drilldownSlice.column && v.column !== "Overall"
          )
        : undefined;

    return (
      <div className={styles.overall}>
        {/* this.renderSubControls() */}
        <div className={styles.overallSection}>
          <div className={styles.overallSectionBackground} />
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div className={styles.bHeader}>{"Current Resourcing"}</div>
              <div className={styles.sHero} style={{ justifyContent: "flex-start" }}>
                {(optimized.currentSpend < 0 ? "-" : "") + "$"}
                <NumberLabel params={numberFormatParams}>{Math.abs(optimized.currentSpend)}</NumberLabel>
                <div
                  className={
                    styles.oItemHeader +
                    " " +
                    (optimized.currentSpend > optimized.totalCost
                      ? styles.oItemHeaderNegative
                      : styles.oItemHeaderPositive)
                  }
                >
                  <div className={styles.leftRadius} />
                  <div className={styles.oIContent}>
                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: "5px" }} />
                    {(optimized.currentSpend > optimized.totalCost
                      ? "You are Overspending by "
                      : "You are Underspending by ") +
                      (Math.abs(Math.round((optimized.totalCost - optimized.currentSpend) / optimized.currentSpend)) > 2
                        ? Math.abs(
                            Math.round((optimized.totalCost - optimized.currentSpend) / optimized.currentSpend)
                          ) + "x"
                        : Math.round(
                            Math.abs((optimized.totalCost - optimized.currentSpend) / optimized.currentSpend) * 100
                          ) + "%")}
                  </div>
                  <div className={styles.rightRadius} />
                </div>
              </div>
              <div className={styles.mMix}>{"Marketing Mix: 45/40/15"}</div>
              <div className={styles.mItemMid + " " + styles.dropShadow}>
                {isEditMarketing === true ? (
                  <div className={styles.bHeaderHolder}>
                    <div className={styles.newItemHeader}>{"Edit Marketing Budget"}</div>
                    <div className={styles.tInput}>
                      <LineInput isMediumBox defaultValue={optimized.budget} onChange={(val) => setBudget(val)} />
                      <Button onClick={() => this.setState({ isEditMarketing: false })} style={{ marginLeft: "5px" }}>
                        {"OK"}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={styles.newItemHeader + " " + styles.subBackground}>
                      {"Optimal Resourcing"}
                      <FontAwesomeIcon
                        className={styles.editIcon}
                        icon={faEdit}
                        onClick={() => this.setState({ isEditMarketing: true })}
                      />
                    </div>
                    <div className={styles.newOItemContent}>
                      <div className={styles.cHero}>
                        {(optimized.budget < 0 ? "-" : "") + "$"}
                        <NumberLabel params={numberFormatParams}>{Math.abs(optimized.totalCost)}</NumberLabel>
                        <span
                          className={
                            styles.oDelta +
                            " " +
                            (optimized.totalCost - optimized.currentSpend < 0 ? styles.decrease : styles.increase)
                          }
                        >
                          <FontAwesomeIcon
                            style={{ marginRight: "2px" }}
                            icon={
                              optimized.totalCost - optimized.currentSpend < 0
                                ? faArrowAltCircleDown
                                : faArrowAltCircleUp
                            }
                          />
                          <NumberLabel params={numberFormatParams}>
                            {Math.abs(optimized.totalCost - optimized.currentSpend)}
                          </NumberLabel>
                        </span>
                      </div>
                      <div className={styles.sSubItem}>
                        <span>
                          {"Marketing spend " +
                            (optimized.currentSpend - optimized.totalCost > 0 ? "decreases" : "increases") +
                            " to " +
                            this.numberWithCommas(Math.round(optimized.totalCost)) +
                            " from " +
                            this.numberWithCommas(Math.round(optimized.currentSpend))}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.midHeaderHolder}>
              <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                {"Current Revenue"}
              </div>
              <div className={styles.sHero}>
                {(optimized.currentRevenue < 0 ? "-" : "") + "$"}
                <NumberLabel params={numberFormatParams}>{Math.abs(optimized.currentRevenue)}</NumberLabel>
              </div>
              <div style={{ height: "20px" }} />
            </div>
            <div className={styles.mItemMid + " " + styles.dropShadow}>
              <div className={styles.newItemHeader + " " + styles.subBackground}>{"Expected Revenue"}</div>
              <div className={styles.newOItemContent}>
                <div className={styles.cHero}>
                  {(optimized.revenue < 0 ? "-" : "") + "$"}
                  <NumberLabel params={numberFormatParams}>{Math.abs(optimized.revenue)}</NumberLabel>
                  <span
                    className={styles.oDelta + " " + (optimized.revenueDelta > 0 ? styles.increase : styles.decrease)}
                  >
                    <FontAwesomeIcon
                      style={{ marginRight: "2px" }}
                      icon={optimized.revenueDelta > 0 ? faArrowAltCircleUp : faArrowAltCircleDown}
                    />
                    <NumberLabel params={numberFormatParams}>{Math.abs(optimized.revenueDelta)}</NumberLabel>
                  </span>
                </div>
                <div className={styles.sSubItem}>
                  <span>
                    {"Revenue " +
                      (optimized.revenueDelta > 0 ? "increases" : "decreases") +
                      " to " +
                      this.numberWithCommas(Math.round(optimized.revenue)) +
                      " from " +
                      this.numberWithCommas(Math.round(optimized.currentRevenue))}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div className={styles.midHeaderHolder}>
                <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                  {"Current Profit"}
                </div>
                <div className={styles.sHero}>
                  {(optimized.currentProfit < 0 ? "-" : "") + "$"}
                  <NumberLabel params={numberFormatParams}>{Math.abs(optimized.currentProfit)}</NumberLabel>
                </div>
              </div>
            </div>
            <div style={{ height: "20px" }} />
            {this.renderProfitBox()}
          </div>
        </div>
        <div className={styles.newBottomContent}>
          <div className={styles.oItem} style={{ marginLeft: "20px" }}>
            <div className={styles.nItemHeader + " " + styles.subBackground} style={{ textAlign: "center" }}>
              {"Marketing Overview"}
            </div>
            <div className={styles.oItemBotHolder}>
              <div className={styles.oItemBotItem}>
                <div className={styles.oItemBotHeader}>{"Key Marketing Drivers"}</div>
                <div className={styles.oItemBotSubHeader} style={{ textTransform: "uppercase" }}>
                  {"RANKED BY " + optimized.setup.netImpactLabel}
                </div>
                {/*
                <div className={styles.oItemBotButtonHolder}>
                  <ButtonGroup>
                    <Button
                      active={true}
                      style={{ padding: "6px", height: "34px" }}
                    >
                      {"Overall"}
                    </Button>
                    <Button
                      style={{ padding: "6px", height: "34px" }}
                    >
                      {modelGroups.drilldownColumn}
                    </Button>
                  </ButtonGroup>
                </div>
                */}
                <div className={styles.oItemBotContent}>
                  {topDrivers &&
                    topDrivers.driver &&
                    topDrivers.driver
                      .filter((m, i) => i < 10)
                      .map((m, i) => (
                        <div className={styles.driverItem} key={i}>
                          <span className={styles.botDelta + " " + (m.value > 0 ? styles.increase : styles.decrease)}>
                            <FontAwesomeIcon
                              style={{ marginRight: "5px" }}
                              icon={m.value > 0 ? faArrowAltCircleUp : faArrowAltCircleDown}
                            />
                          </span>
                          <div>
                            <div style={{ fontWeight: "bold" }}>{m.name}</div>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              {isEditMarketingImpacts ? (
                <div className={styles.oItemBotItem}>
                  <div className={styles.absoluteFrontier + " " + styles.dropShadow}>
                    <RunPlotContainer id={optimized.id} plotType={"Capacity Comparison"} isOptimizer />
                  </div>
                  <div className={styles.oItemBotHeader}>
                    {"Edit Impacts"}
                    <Button
                      style={{ marginLeft: "5px", padding: "5px" }}
                      onClick={() => this.setState({ isEditMarketingImpacts: false })}
                    >
                      {"OK"}
                    </Button>
                    {hasCustomValues && (
                      <div className={styles.customValueToggle}>
                        <ButtonGroup>
                          <Button
                            active={isHideCustomValues !== true}
                            onClick={() => this.setState({ isHideCustomValues: false })}
                            style={{ padding: "2px" }}
                          >
                            {"Blueprint"}
                          </Button>
                          <Button
                            active={isHideCustomValues === true}
                            onClick={() => this.setState({ isHideCustomValues: true })}
                            style={{ padding: "2px" }}
                          >
                            {"Cost & Benefits"}
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                  </div>
                  {showCustomValues ? (
                    <div className={styles.oItemBotContent} style={{ height: "30vh" }}>
                      <div className={styles.assumptionItem}>
                        {Object.keys(optimized.setup.customValues).map((v, i) => (
                          <div key={i}>
                            <div className={styles.assumptionTop}>{v}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.customValues[v]}
                                onChange={(val) => updateCustomValue(optimized.id, optimized.setup.blueprintId, v, val)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className={styles.oItemBotContent} style={{ height: "30vh" }}>
                      <div className={styles.assumptionItem}>
                        <div className={styles.sFlex}>
                          <div>
                            <div className={styles.assumptionTop}>{optimized.setup.truePositiveLabel}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.conversionGain}
                                onChange={(val) => updateConversionGain(optimized.id, val)}
                              />
                            </div>
                          </div>
                          <div>
                            <div className={styles.assumptionTop}>{"Count"}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.truePositive}
                                onChange={(val) => updateTruePositive(optimized.id, val)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles.sFlex}>
                          <div>
                            <div className={styles.assumptionTop}>{optimized.setup.falsePositiveLabel}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.conversionCost}
                                onChange={(val) => updateConversionCost(optimized.id, val)}
                              />
                            </div>
                          </div>
                          <div>
                            <div className={styles.assumptionTop}>{"Count"}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.falsePositive}
                                onChange={(val) => updateFalsePositive(optimized.id, val)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles.sFlex}>
                          <div>
                            <div className={styles.assumptionTop}>{optimized.setup.trueNegativeLabel}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.conversionSaved}
                                onChange={(val) => updateConversionSaved(optimized.id, val)}
                              />
                            </div>
                          </div>
                          <div>
                            <div className={styles.assumptionTop}>{"Count"}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.trueNegative}
                                onChange={(val) => updateTrueNegative(optimized.id, val)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles.sFlex}>
                          <div>
                            <div className={styles.assumptionTop}>{optimized.setup.falseNegativeLabel}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.conversionMissed}
                                onChange={(val) => updateConversionMissed(optimized.id, val)}
                              />
                            </div>
                          </div>
                          <div>
                            <div className={styles.assumptionTop}>{"Count"}</div>
                            <div className={styles.assumptionBot}>
                              <LineInput
                                isMediumBox
                                defaultValue={optimized.setup.falseNegative}
                                onChange={(val) => updateFalseNegative(optimized.id, val)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className={styles.oItemBotItem}>
                  <div className={styles.oItemBotHeader}>
                    {"Key Assumptions"}
                    <FontAwesomeIcon
                      className={styles.editIcon}
                      icon={faEdit}
                      onClick={() => this.setState({ isEditMarketingImpacts: true })}
                    />
                    {hasCustomValues && (
                      <div className={styles.customValueToggle}>
                        <ButtonGroup>
                          <Button
                            active={isHideCustomValues !== true}
                            onClick={() => this.setState({ isHideCustomValues: false })}
                            style={{ padding: "2px" }}
                          >
                            {"Blueprint"}
                          </Button>
                          <Button
                            active={isHideCustomValues === true}
                            onClick={() => this.setState({ isHideCustomValues: true })}
                            style={{ padding: "2px" }}
                          >
                            {"Cost & Benefits"}
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                  </div>
                  {showCustomValues ? (
                    <div className={styles.oItemBotContent} style={{ marginTop: "10px", height: "30vh" }}>
                      <div className={styles.assumptionItem}>
                        {Object.keys(optimized.setup.customValues).map((c, i) => (
                          <div key={i}>
                            <div className={styles.assumptionTop}>{c}</div>
                            <div className={styles.assumptionBot}>
                              <ImpactSlider
                                impacts={modelGroups.drilldownValues.map((v) => ({
                                  value: v.setup.customValues[v],
                                  drilldownValue: v.value
                                }))}
                                currentImpact={optimized.setup.customValues[c]}
                                drilldownValue={optimizer.drilldownValue}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div>
                      {modelGroups && modelGroups.drilldownValues && (
                        <div className={styles.oItemBotContent} style={{ marginTop: "10px", height: "30vh" }}>
                          <div className={styles.assumptionItem}>
                            <div className={styles.assumptionTop}>{optimized.setup.truePositiveLabel}</div>
                            <div className={styles.assumptionBot}>
                              <ImpactSlider
                                impacts={modelGroups.drilldownValues.map((v) => ({
                                  value: v.setup.conversionGain,
                                  drilldownValue: v.value
                                }))}
                                currentImpact={optimized.setup.conversionGain}
                                drilldownValue={optimizer.drilldownValue}
                              />
                            </div>
                            <div className={styles.assumptionTop}>{optimized.setup.falsePositiveLabel}</div>
                            <div className={styles.assumptionBot}>
                              <ImpactSlider
                                impacts={modelGroups.drilldownValues.map((v) => ({
                                  value: v.setup.conversionCost,
                                  drilldownValue: v.value
                                }))}
                                currentImpact={optimized.setup.conversionCost}
                                drilldownValue={optimizer.drilldownValue}
                              />
                            </div>
                            <div className={styles.assumptionTop}>{optimized.setup.trueNegativeLabel}</div>
                            <div className={styles.assumptionBot}>
                              <ImpactSlider
                                impacts={modelGroups.drilldownValues.map((v) => ({
                                  value: v.setup.conversionSaved,
                                  drilldownValue: v.value
                                }))}
                                currentImpact={optimized.setup.conversionSaved}
                                drilldownValue={optimizer.drilldownValue}
                              />
                            </div>
                            <div className={styles.assumptionTop}>{optimized.setup.falseNegativeLabel}</div>
                            <div className={styles.assumptionBot}>
                              <ImpactSlider
                                impacts={modelGroups.drilldownValues.map((v) => ({
                                  value: v.setup.conversionGain,
                                  drilldownValue: v.value
                                }))}
                                currentImpact={optimized.setup.conversionMissed}
                                drilldownValue={optimizer.drilldownValue}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {optimizer.drilldownValue === "Overall" ? (
                <div className={styles.oItemBotItem}>
                  <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                    {"Budget Breakdown"}
                  </div>
                  <div className={styles.pieHolder}>
                    <OptimizerPieChart
                      pData={[
                        {
                          name: "Overspend",
                          value: modelGroups.overspendCount
                        },
                        {
                          name: "Underspend",
                          value: modelGroups.underspendCount
                        },
                        { name: "No Issue", value: modelGroups.noIssueCount },
                        { name: "No Data", value: 0 }
                      ]}
                    />
                  </div>
                </div>
              ) : (
                <div className={styles.oItemBotItem}>
                  <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                    {"Optimal Mix"}
                  </div>
                  {mTotal !== 0 ? (
                    <div className={styles.pieHolder}>
                      <OptimizerPieChart
                        pData={Object.keys(groupInfo.marketing[optimizer.drilldownValue]).map((v) => ({
                          name: v,
                          value: Number(
                            ((groupInfo.marketing[optimizer.drilldownValue][v].cost / mTotal) * 100).toFixed(2)
                          )
                        }))}
                      />
                    </div>
                  ) : (
                    <div className={styles.pieHolder}>
                      <OptimizerPieChart
                        secondaryColors
                        pData={
                          otherSlices
                            ? otherSlices.map((s) => ({
                                name: s.value,
                                value: Math.round(s.pctOfRows * 100)
                              }))
                            : [
                                {
                                  name: "Digital",
                                  value: 75,
                                  color: "#512f77"
                                },
                                {
                                  name: "Events",
                                  value: 20
                                },
                                {
                                  name: "Other",
                                  value: 5
                                }
                              ]
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.overallBody}></div>
      </div>
    );
  }

  renderSetupPanel() {
    const {
      errorRuns,
      optimizer,
      optimized,
      modelGroups,
      setFirstRunId,
      setSecondRunId,
      setMarketingRunId,
      setSalesRunId,
      setDrilldownColumn,
      setSalesDrilldown,
      setMarketingDrilldown,
      updateOverallRun,
      updateSalesRun,
      updateMarketingRun,
      updateCombined,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed
    } = this.props;
    const { isSetup, setupSections } = this.state;

    const roleOptions = ROLE_OPTIONS;

    return (
      <div
        className={styles.setupPanel + " " + (isSetup ? styles.rightOpen : "")}
        style={isSetup ? { width: "1000px" } : {}}
      >
        <div className={styles.rightHeader}>{"Admin"}</div>
        <div className={styles.rightContent}>
          {optimized && optimized && optimized.setup && (
            <div className={styles.oBodySection}>
              <div>{optimized.setup.label}</div>
            </div>
          )}
          <div className={styles.oBodySection}>
            <Button isDark>{"Create New Specialization"}</Button>
          </div>
          {modelGroups &&
            modelGroups.drilldownValues &&
            modelGroups.drilldownValues.map((v, i) => {
              const sectionKey = v.column + " - " + v.value;
              const activeSection = setupSections[sectionKey] ? setupSections[sectionKey] : "USERS";

              return (
                <div className={styles.sBodySection} key={i}>
                  <div className={styles.flex}>
                    <div style={{ width: "33%" }}>
                      <div className={styles.oBodyHeader}>{"Specialization"}</div>
                      <div>{sectionKey}</div>
                    </div>
                    <div style={{ width: "33%", textAlign: "center" }}>
                      <ButtonGroup>
                        <Button
                          isDark
                          active={activeSection === "USERS"}
                          onClick={() =>
                            this.setState({
                              setupSections: {
                                ...setupSections,
                                [sectionKey]: "USERS"
                              }
                            })
                          }
                        >
                          {"Users"}
                        </Button>
                        <Button
                          isDark
                          active={activeSection === "ASSUMPTIONS"}
                          onClick={() =>
                            this.setState({
                              setupSections: {
                                ...setupSections,
                                [sectionKey]: "ASSUMPTIONS"
                              }
                            })
                          }
                        >
                          {"Assumptions"}
                        </Button>
                        <Button
                          isDark
                          active={activeSection === "FRONTIERS"}
                          onClick={() =>
                            this.setState({
                              setupSections: {
                                ...setupSections,
                                [sectionKey]: "FRONTIERS"
                              }
                            })
                          }
                        >
                          {"Frontiers"}
                        </Button>
                      </ButtonGroup>
                    </div>
                    <div style={{ width: "33%", textAlign: "right" }}>
                      <Button isDark>{"Delete"}</Button>
                    </div>
                  </div>
                  <div className={styles.sectionContent}>
                    {activeSection === "USERS" && (
                      <div className={styles.users}>
                        <div className={styles.oBodySection}>
                          <Button isDark>{"Add User"}</Button>
                        </div>
                        <div className={styles.usersContent}>
                          <div>{modelGroups.created_by.fullname}</div>
                          <div className={styles.selHolder}>
                            <Select options={roleOptions} defaultValue={roleOptions[0]} styles={darkSelectStyle} />
                          </div>
                          <Button isDark>{"Delete"}</Button>
                        </div>
                      </div>
                    )}
                    {activeSection === "ASSUMPTIONS" && (
                      <div classsName={styles.users}>
                        <div className={styles.oBodySection}>
                          {this.renderAssumptions()}
                          <Button isDark>{"Save New Assumption"}</Button>
                        </div>
                      </div>
                    )}
                    {activeSection === "FRONTIERS" && (
                      <div className={styles.oBodySection + " " + styles.frontiers}>
                        <div className={styles.oBodyHeader}>{"Approved"}</div>
                        <RunItemContainer id={v.runId} isFrontier />
                        <RunViewContainer type={"all"} hideFirstTile isFrontierView onClick={() => {}} />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  renderAssumptions() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;

    return (
      <div className={styles.oBodySection}>
        <div className={styles.oBodyHeader}>{"Approved"}</div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionGain}
                onChange={(val) => updateConversionGain(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.truePositive}
                onChange={(val) => updateTruePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionCost}
                onChange={(val) => updateConversionCost(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falsePositive}
                onChange={(val) => updateFalsePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionSaved}
                onChange={(val) => updateConversionSaved(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.trueNegative}
                onChange={(val) => updateTrueNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionMissed}
                onChange={(val) => updateConversionMissed(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falseNegative}
                onChange={(val) => updateFalseNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRightPanel() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;
    const { isRightOpen } = this.state;

    return (
      <div className={styles.rightPanel + " " + (isRightOpen ? styles.rightOpen : "")}>
        <div className={styles.rightHeader}>{"Impacts"}</div>
        <div className={styles.rightContent}>
          {optimized && optimized && optimized.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Marketing"}</div>
              <div>{optimized.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {optimized && optimized.second && optimized.second.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Sales"}</div>
              <div>{optimized.second.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSubControls() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, setOverallScaleFromRowCount } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    return (
      <div className={styles.tHeader}>
        {/*
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Time Period"}</div>
          <div className={styles.tInput}>
            <Select
              options={[
                { value: "Day", label: "Day" },
                { value: "Week", label: "Week" },
                { value: "Month", label: "Month" },
                { value: "Quarter", label: "Quarter" },
                { value: "Year", label: "Year" }
              ]}
              value={timePeriod}
              onChange={val => this.setState({ timePeriod: val })}
              className={styles.tSelect}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
      */}
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Budget"}</div>
          <div className={styles.tInput}>
            <LineInput isMediumBox isDark defaultValue={optimized.budget} onChange={(val) => setMarketingBudget(val)} />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Sales Budget"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.second.budget}
              onChange={(val) => setSalesBudget(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Total Prospects"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.totalProspects}
              onChange={(val) => setOverallScaleFromRowCount(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Qualified Leads"}</div>
          <div className={styles.tInput}>
            <NumberLabel params={numberFormatParams}>{optimized.totalWon}</NumberLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem} style={{ borderRight: "0px" }}>
          <div className={styles.tTitle}>{"Wins"}</div>
          <div className={styles.tInput}>
            <NumberLabel params={numberFormatParams}>{optimized.second.totalWon}</NumberLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
      </div>
    );
  }

  renderDrilldown() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, modelGroups } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    return (
      <div className={styles.drilldown}>
        {/* this.renderSubControls() */}
        <div className={styles.sHeader}>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Marketing Spend"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + "$"}
              <NumberLabel params={numberFormatParams}>{Math.abs(optimized.totalCost)}</NumberLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Per Lead Cost"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + "$"}
              <NumberLabel params={numberFormatParams}>{Math.abs(optimized.setup.conversionCost)}</NumberLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Expected Leads"}</div>
            <div className={styles.sHero}>{Math.round(optimized.totalWon)}</div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Sales Expense"}</div>
            <div className={styles.sHero}>
              {(optimized.second.totalCost < 0 ? "-" : "") + "$"}
              <NumberLabel params={numberFormatParams}>{Math.abs(optimized.second.totalCost)}</NumberLabel>
            </div>
          </div>
          <div className={styles.sItem} style={{ marginRight: "350px" }}>
            <div className={styles.sTitle}>{"Wins"}</div>
            <div className={styles.sHero}>{Math.round(optimized.second.totalWon)}</div>
          </div>
        </div>
        <div className={styles.oBody}>
          {<SankeyChart optimized={optimized} />}
          {this.renderProfitBox(
            {
              marginTop: "0px",
              marginBottom: "575px",
              textAlign: "center",
              whiteSpace: "nowrap",
              marginRight: "20px",
              marginLeft: "-50px",
              zIndex: "2"
            },
            true
          )}
        </div>
      </div>
    );
  }
}
